/**
 * Lightweight GA4 Click Tracking Utility
 * Usage:
 * <button data-ga4="signup_click">Sign Up</button>
 * <button data-ga4="add_to_cart" data-ga4-product-id="123">Add to Cart</button>
 *
 * Any data-ga4-* attribute becomes a GA4 event parameter, snake_cased:
 *   data-ga4-notification-tag="LoyaltyBanner"  ->  notification_tag: "LoyaltyBanner"
 *
 * data-ga4-params='{"a":1}' still works and is applied last, so it wins.
 * Append ?ga4debug to any URL to log events to the console.
 */

(function() {
  'use strict';
  window.dataLayer = window.dataLayer || [];
  const throttleMap = new WeakMap();
  const THROTTLE_DELAY = 1000;
  const DEBUG = /[?&]ga4debug/.test(window.location.search);

  function isThrottled(element) {
    const lastClick = throttleMap.get(element);
    const now = Date.now();
    if (lastClick && now - lastClick < THROTTLE_DELAY) {
      return true;
    }
    throttleMap.set(element, now);
    return false;
  }

  function getElementText(element) {
    return (element.textContent || element.innerText || '').trim();
  }

  function parseParams(paramsString) {
    try {
      return JSON.parse(paramsString);
    } catch (e) {
      console.warn('GA4 Tracking: Invalid JSON in data-ga4-params:', paramsString);
      return {};
    }
  }

  // data-ga4-notification-tag -> notification_tag
  function datasetParams(element) {
    const params = {};
    Object.keys(element.dataset).forEach(function(key) {
      if (key === 'ga4' || key === 'ga4Params' || key.indexOf('ga4') !== 0) {
        return;
      }
      const name = key.slice(3).replace(/([A-Z])/g, function(match, letter, offset) {
        return (offset ? '_' : '') + letter.toLowerCase();
      });
      if (name) {
        params[name] = element.dataset[key];
      }
    });
    return params;
  }

  function trackEvent(element) {
    const eventName = element.getAttribute('data-ga4');
    if (!eventName) {
      return;
    }
    if (isThrottled(element)) {
      return;
    }
    const params = {
      element_text: getElementText(element),
      page_location: window.location.href,
    };
    Object.assign(params, datasetParams(element));
    const customParams = element.getAttribute('data-ga4-params');
    if (customParams) {
      Object.assign(params, parseParams(customParams));
    }
    const eventData = {
      event: eventName,
      ...params
    };
    if (DEBUG) {
      console.log('GA4 Tracking: Event fired', eventData);
    }
    window.dataLayer.push(eventData);

    // gtag.js ignores GTM-shaped dataLayer pushes, so send it directly too.
    if (typeof window.gtag === 'function') {
      window.gtag('event', eventName, params);
    }
  }

  function handleClick(event) {
    const target = event.target.closest('[data-ga4]');
    if (target) {
      trackEvent(target);
    }
  }

  document.addEventListener('click', handleClick, true);
})();
